// Styles
import './Scandit.scss';

// Libs
import React from 'react';

// Blocks
import BarcodeScanner from '@/ebat/components/blocks/BarcodeScanner/BarcodeScanner';

// PropTypes
import { ScanditDefaultProps, ScanditPropTypes } from './Scandit.proptypes';

const Scandit = ({
  onScanResult,
  onValidatePopin,
  isLogin,
  handleUpdateQuickEntry,
}) => (
  <BarcodeScanner
    onScanResult={onScanResult}
    onValidatePopin={onValidatePopin}
    isLogin={isLogin}
    handleUpdateQuickEntry={handleUpdateQuickEntry}
  />
);

Scandit.defaultProps = {
  ...ScanditDefaultProps,
};

Scandit.propTypes = {
  ...ScanditPropTypes,
};

export default Scandit;
